import React from 'react';
import Flag from '../../../redux/flags/Flag';
import HeartIcon from '../../../Icons/Heart';
import StatLayout from '../StatLayout';
import LoveMeter from './LoveMeter';
export var LoveStat = function (_a) {
    var isOwner = _a.isOwner, _b = _a.deviation.stats, loveLevel = (_b === void 0 ? { loveLevel: 0 } : _b).loveLevel;
    return (React.createElement(Flag, { condition: "lovemeter" },
        React.createElement(StatLayout, { name: "love", hasValue: true, icon: isOwner ? HeartIcon : LoveMeter, value: loveLevel })));
};
export default LoveStat;
//# sourceMappingURL=LoveStat.js.map